/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import * as t from "react";
import { ActionSheet as u, ActionSheetFooter as v } from "@progress/kendo-react-layout";
import { checkIcon as C } from "@progress/kendo-svg-icons";
import { Button as o } from "@progress/kendo-react-buttons";
import { useAdaptiveModeContext as g } from "@progress/kendo-react-common";
const I = (n) => {
  const {
    footer: e,
    windowWidth: l = 0,
    mobileFilter: r,
    children: s,
    navigatable: c,
    navigatableElements: m,
    expand: d,
    animation: p,
    title: b,
    subTitle: f,
    onClose: i
  } = n, h = () => /* @__PURE__ */ t.createElement(
    o,
    {
      tabIndex: 0,
      "aria-label": "Cancel",
      "aria-disabled": "false",
      type: "button",
      fillMode: "flat",
      size: "large",
      themeColor: "primary",
      svgIcon: C,
      onClick: i
    }
  ), a = g(), x = {
    navigatable: c || !1,
    navigatableElements: m || [],
    expand: d,
    animation: p !== !1,
    suffixActions: h(),
    filter: r,
    onClose: i,
    animationStyles: a && l <= a.small ? { top: 0, width: "100%", height: "100%" } : void 0,
    title: b,
    subTitle: f,
    className: "k-adaptive-actionsheet",
    position: a && l <= a.small ? "fullscreen" : void 0
  };
  return /* @__PURE__ */ t.createElement(u, { ...x }, s, e && /* @__PURE__ */ t.createElement(v, { className: "k-actions k-actions-stretched" }, /* @__PURE__ */ t.createElement(
    o,
    {
      size: "large",
      tabIndex: 0,
      "aria-label": e.cancelText,
      "aria-disabled": "false",
      type: "button",
      onClick: e.onCancel
    },
    e.cancelText
  ), /* @__PURE__ */ t.createElement(
    o,
    {
      tabIndex: 0,
      themeColor: "primary",
      size: "large",
      "aria-label": e.applyText,
      "aria-disabled": "false",
      type: "button",
      onClick: e.onApply
    },
    e.applyText
  )));
};
export {
  I as AdaptiveMode
};
